import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  TemplateRef
} from '@angular/core';

@Component({
    selector: 'ppl-content-title',
    templateUrl: './content-title.component.html',
    styleUrls: ['./content-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PplContentTitleComponent {
  @Input() label: string;
  @Input() icon: string | null;
  @Input() infoMessage?: string | TemplateRef<any>;
  @Input() labelTemplate?: TemplateRef<any>;
  @Input() actionTemplate?: TemplateRef<any>;
  @Input() @HostBinding('class.flex') flex = false;
}
